// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v7.34.1
// source: testing.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Timestamp } from "./google/protobuf/timestamp";

export const protobufPackage = "testing";

export interface Testing {
  testCases: TestCase[];
}

export interface FunctionCallAssertionArgument {
  valueType: string;
  assertionType: string;
  expectedValue?: string | undefined;
}

export interface FunctionCallAssertion {
  name: string;
  arguments: { [key: string]: FunctionCallAssertionArgument };
  isAsserted: boolean;
}

export interface FunctionCallAssertion_ArgumentsEntry {
  key: string;
  value: FunctionCallAssertionArgument | undefined;
}

export interface TestCase {
  id: string;
  name: string;
  scenario: string;
  assertions: string[];
  functionCalls: FunctionCallAssertion[];
  variantId?: string | undefined;
  language: string;
  createdBy: string;
  createdAt: Date | undefined;
  updatedBy?: string | undefined;
  updatedAt?: Date | undefined;
  tags: string[];
  simulatedAt?: Date | undefined;
  expectedOutcome: string;
}

export interface CreateTestCase {
  id: string;
  name: string;
  scenario: string;
  variantId?: string | undefined;
  language: string;
  simulatedAt?: Date | undefined;
  expectedOutcome: string;
}

export interface UpdateTestCase {
  id: string;
  name?: string | undefined;
  scenario?: string | undefined;
  variantId?: string | undefined;
  language?: string | undefined;
  simulatedAt?: Date | undefined;
  expectedOutcome?: string | undefined;
}

export interface DeleteTestCase {
  id: string;
}

export interface SetTestCaseAssertions {
  id: string;
  assertions: string[];
}

export interface SetTestCaseFunctionCalls {
  id: string;
  functionCalls: FunctionCallAssertion[];
}

export interface SetTestCaseTags {
  id: string;
  tags: string[];
}

function createBaseTesting(): Testing {
  return { testCases: [] };
}

export const Testing: MessageFns<Testing> = {
  encode(message: Testing, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.testCases) {
      TestCase.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Testing {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTesting();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.testCases.push(TestCase.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Testing {
    return {
      testCases: globalThis.Array.isArray(object?.testCases)
        ? object.testCases.map((e: any) => TestCase.fromJSON(e))
        : globalThis.Array.isArray(object?.test_cases)
        ? object.test_cases.map((e: any) => TestCase.fromJSON(e))
        : [],
    };
  },

  toJSON(message: Testing): unknown {
    const obj: any = {};
    if (message.testCases?.length) {
      obj.testCases = message.testCases.map((e) => TestCase.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<Testing>): Testing {
    return Testing.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Testing>): Testing {
    const message = createBaseTesting();
    message.testCases = object.testCases?.map((e) => TestCase.fromPartial(e)) || [];
    return message;
  },
};

function createBaseFunctionCallAssertionArgument(): FunctionCallAssertionArgument {
  return { valueType: "", assertionType: "", expectedValue: undefined };
}

export const FunctionCallAssertionArgument: MessageFns<FunctionCallAssertionArgument> = {
  encode(message: FunctionCallAssertionArgument, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.valueType !== "") {
      writer.uint32(10).string(message.valueType);
    }
    if (message.assertionType !== "") {
      writer.uint32(18).string(message.assertionType);
    }
    if (message.expectedValue !== undefined) {
      writer.uint32(26).string(message.expectedValue);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FunctionCallAssertionArgument {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFunctionCallAssertionArgument();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.valueType = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.assertionType = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.expectedValue = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FunctionCallAssertionArgument {
    return {
      valueType: isSet(object.valueType)
        ? globalThis.String(object.valueType)
        : isSet(object.value_type)
        ? globalThis.String(object.value_type)
        : "",
      assertionType: isSet(object.assertionType)
        ? globalThis.String(object.assertionType)
        : isSet(object.assertion_type)
        ? globalThis.String(object.assertion_type)
        : "",
      expectedValue: isSet(object.expectedValue)
        ? globalThis.String(object.expectedValue)
        : isSet(object.expected_value)
        ? globalThis.String(object.expected_value)
        : undefined,
    };
  },

  toJSON(message: FunctionCallAssertionArgument): unknown {
    const obj: any = {};
    if (message.valueType !== "") {
      obj.valueType = message.valueType;
    }
    if (message.assertionType !== "") {
      obj.assertionType = message.assertionType;
    }
    if (message.expectedValue !== undefined) {
      obj.expectedValue = message.expectedValue;
    }
    return obj;
  },

  create(base?: DeepPartial<FunctionCallAssertionArgument>): FunctionCallAssertionArgument {
    return FunctionCallAssertionArgument.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FunctionCallAssertionArgument>): FunctionCallAssertionArgument {
    const message = createBaseFunctionCallAssertionArgument();
    message.valueType = object.valueType ?? "";
    message.assertionType = object.assertionType ?? "";
    message.expectedValue = object.expectedValue ?? undefined;
    return message;
  },
};

function createBaseFunctionCallAssertion(): FunctionCallAssertion {
  return { name: "", arguments: {}, isAsserted: false };
}

export const FunctionCallAssertion: MessageFns<FunctionCallAssertion> = {
  encode(message: FunctionCallAssertion, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    globalThis.Object.entries(message.arguments).forEach(([key, value]: [string, FunctionCallAssertionArgument]) => {
      FunctionCallAssertion_ArgumentsEntry.encode({ key: key as any, value }, writer.uint32(18).fork()).join();
    });
    if (message.isAsserted !== false) {
      writer.uint32(24).bool(message.isAsserted);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FunctionCallAssertion {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFunctionCallAssertion();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          const entry2 = FunctionCallAssertion_ArgumentsEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.arguments[entry2.key] = entry2.value;
          }
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.isAsserted = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FunctionCallAssertion {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      arguments: isObject(object.arguments)
        ? (globalThis.Object.entries(object.arguments) as [string, any][]).reduce(
          (acc: { [key: string]: FunctionCallAssertionArgument }, [key, value]: [string, any]) => {
            acc[key] = FunctionCallAssertionArgument.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
      isAsserted: isSet(object.isAsserted)
        ? globalThis.Boolean(object.isAsserted)
        : isSet(object.is_asserted)
        ? globalThis.Boolean(object.is_asserted)
        : false,
    };
  },

  toJSON(message: FunctionCallAssertion): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.arguments) {
      const entries = globalThis.Object.entries(message.arguments) as [string, FunctionCallAssertionArgument][];
      if (entries.length > 0) {
        obj.arguments = {};
        entries.forEach(([k, v]) => {
          obj.arguments[k] = FunctionCallAssertionArgument.toJSON(v);
        });
      }
    }
    if (message.isAsserted !== false) {
      obj.isAsserted = message.isAsserted;
    }
    return obj;
  },

  create(base?: DeepPartial<FunctionCallAssertion>): FunctionCallAssertion {
    return FunctionCallAssertion.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FunctionCallAssertion>): FunctionCallAssertion {
    const message = createBaseFunctionCallAssertion();
    message.name = object.name ?? "";
    message.arguments = (globalThis.Object.entries(object.arguments ?? {}) as [string, FunctionCallAssertionArgument][])
      .reduce(
        (
          acc: { [key: string]: FunctionCallAssertionArgument },
          [key, value]: [string, FunctionCallAssertionArgument],
        ) => {
          if (value !== undefined) {
            acc[key] = FunctionCallAssertionArgument.fromPartial(value);
          }
          return acc;
        },
        {},
      );
    message.isAsserted = object.isAsserted ?? false;
    return message;
  },
};

function createBaseFunctionCallAssertion_ArgumentsEntry(): FunctionCallAssertion_ArgumentsEntry {
  return { key: "", value: undefined };
}

export const FunctionCallAssertion_ArgumentsEntry: MessageFns<FunctionCallAssertion_ArgumentsEntry> = {
  encode(message: FunctionCallAssertion_ArgumentsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      FunctionCallAssertionArgument.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FunctionCallAssertion_ArgumentsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFunctionCallAssertion_ArgumentsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = FunctionCallAssertionArgument.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FunctionCallAssertion_ArgumentsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? FunctionCallAssertionArgument.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: FunctionCallAssertion_ArgumentsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = FunctionCallAssertionArgument.toJSON(message.value);
    }
    return obj;
  },

  create(base?: DeepPartial<FunctionCallAssertion_ArgumentsEntry>): FunctionCallAssertion_ArgumentsEntry {
    return FunctionCallAssertion_ArgumentsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FunctionCallAssertion_ArgumentsEntry>): FunctionCallAssertion_ArgumentsEntry {
    const message = createBaseFunctionCallAssertion_ArgumentsEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? FunctionCallAssertionArgument.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseTestCase(): TestCase {
  return {
    id: "",
    name: "",
    scenario: "",
    assertions: [],
    functionCalls: [],
    variantId: undefined,
    language: "",
    createdBy: "",
    createdAt: undefined,
    updatedBy: undefined,
    updatedAt: undefined,
    tags: [],
    simulatedAt: undefined,
    expectedOutcome: "",
  };
}

export const TestCase: MessageFns<TestCase> = {
  encode(message: TestCase, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.scenario !== "") {
      writer.uint32(26).string(message.scenario);
    }
    for (const v of message.assertions) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.functionCalls) {
      FunctionCallAssertion.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.variantId !== undefined) {
      writer.uint32(50).string(message.variantId);
    }
    if (message.language !== "") {
      writer.uint32(58).string(message.language);
    }
    if (message.createdBy !== "") {
      writer.uint32(66).string(message.createdBy);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(74).fork()).join();
    }
    if (message.updatedBy !== undefined) {
      writer.uint32(82).string(message.updatedBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(90).fork()).join();
    }
    for (const v of message.tags) {
      writer.uint32(98).string(v!);
    }
    if (message.simulatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.simulatedAt), writer.uint32(106).fork()).join();
    }
    if (message.expectedOutcome !== "") {
      writer.uint32(114).string(message.expectedOutcome);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TestCase {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTestCase();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.scenario = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.assertions.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.functionCalls.push(FunctionCallAssertion.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.variantId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.language = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.tags.push(reader.string());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.simulatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.expectedOutcome = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TestCase {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      scenario: isSet(object.scenario) ? globalThis.String(object.scenario) : "",
      assertions: globalThis.Array.isArray(object?.assertions)
        ? object.assertions.map((e: any) => globalThis.String(e))
        : [],
      functionCalls: globalThis.Array.isArray(object?.functionCalls)
        ? object.functionCalls.map((e: any) => FunctionCallAssertion.fromJSON(e))
        : globalThis.Array.isArray(object?.function_calls)
        ? object.function_calls.map((e: any) => FunctionCallAssertion.fromJSON(e))
        : [],
      variantId: isSet(object.variantId)
        ? globalThis.String(object.variantId)
        : isSet(object.variant_id)
        ? globalThis.String(object.variant_id)
        : undefined,
      language: isSet(object.language) ? globalThis.String(object.language) : "",
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      tags: globalThis.Array.isArray(object?.tags)
        ? object.tags.map((e: any) => globalThis.String(e))
        : [],
      simulatedAt: isSet(object.simulatedAt)
        ? fromJsonTimestamp(object.simulatedAt)
        : isSet(object.simulated_at)
        ? fromJsonTimestamp(object.simulated_at)
        : undefined,
      expectedOutcome: isSet(object.expectedOutcome)
        ? globalThis.String(object.expectedOutcome)
        : isSet(object.expected_outcome)
        ? globalThis.String(object.expected_outcome)
        : "",
    };
  },

  toJSON(message: TestCase): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.scenario !== "") {
      obj.scenario = message.scenario;
    }
    if (message.assertions?.length) {
      obj.assertions = message.assertions;
    }
    if (message.functionCalls?.length) {
      obj.functionCalls = message.functionCalls.map((e) => FunctionCallAssertion.toJSON(e));
    }
    if (message.variantId !== undefined) {
      obj.variantId = message.variantId;
    }
    if (message.language !== "") {
      obj.language = message.language;
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedBy !== undefined) {
      obj.updatedBy = message.updatedBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.tags?.length) {
      obj.tags = message.tags;
    }
    if (message.simulatedAt !== undefined) {
      obj.simulatedAt = message.simulatedAt.toISOString();
    }
    if (message.expectedOutcome !== "") {
      obj.expectedOutcome = message.expectedOutcome;
    }
    return obj;
  },

  create(base?: DeepPartial<TestCase>): TestCase {
    return TestCase.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TestCase>): TestCase {
    const message = createBaseTestCase();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.scenario = object.scenario ?? "";
    message.assertions = object.assertions?.map((e) => e) || [];
    message.functionCalls = object.functionCalls?.map((e) => FunctionCallAssertion.fromPartial(e)) || [];
    message.variantId = object.variantId ?? undefined;
    message.language = object.language ?? "";
    message.createdBy = object.createdBy ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.updatedBy = object.updatedBy ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.tags = object.tags?.map((e) => e) || [];
    message.simulatedAt = object.simulatedAt ?? undefined;
    message.expectedOutcome = object.expectedOutcome ?? "";
    return message;
  },
};

function createBaseCreateTestCase(): CreateTestCase {
  return {
    id: "",
    name: "",
    scenario: "",
    variantId: undefined,
    language: "",
    simulatedAt: undefined,
    expectedOutcome: "",
  };
}

export const CreateTestCase: MessageFns<CreateTestCase> = {
  encode(message: CreateTestCase, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.scenario !== "") {
      writer.uint32(26).string(message.scenario);
    }
    if (message.variantId !== undefined) {
      writer.uint32(34).string(message.variantId);
    }
    if (message.language !== "") {
      writer.uint32(42).string(message.language);
    }
    if (message.simulatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.simulatedAt), writer.uint32(58).fork()).join();
    }
    if (message.expectedOutcome !== "") {
      writer.uint32(66).string(message.expectedOutcome);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateTestCase {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateTestCase();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.scenario = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.variantId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.language = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.simulatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.expectedOutcome = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateTestCase {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      scenario: isSet(object.scenario) ? globalThis.String(object.scenario) : "",
      variantId: isSet(object.variantId)
        ? globalThis.String(object.variantId)
        : isSet(object.variant_id)
        ? globalThis.String(object.variant_id)
        : undefined,
      language: isSet(object.language) ? globalThis.String(object.language) : "",
      simulatedAt: isSet(object.simulatedAt)
        ? fromJsonTimestamp(object.simulatedAt)
        : isSet(object.simulated_at)
        ? fromJsonTimestamp(object.simulated_at)
        : undefined,
      expectedOutcome: isSet(object.expectedOutcome)
        ? globalThis.String(object.expectedOutcome)
        : isSet(object.expected_outcome)
        ? globalThis.String(object.expected_outcome)
        : "",
    };
  },

  toJSON(message: CreateTestCase): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.scenario !== "") {
      obj.scenario = message.scenario;
    }
    if (message.variantId !== undefined) {
      obj.variantId = message.variantId;
    }
    if (message.language !== "") {
      obj.language = message.language;
    }
    if (message.simulatedAt !== undefined) {
      obj.simulatedAt = message.simulatedAt.toISOString();
    }
    if (message.expectedOutcome !== "") {
      obj.expectedOutcome = message.expectedOutcome;
    }
    return obj;
  },

  create(base?: DeepPartial<CreateTestCase>): CreateTestCase {
    return CreateTestCase.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateTestCase>): CreateTestCase {
    const message = createBaseCreateTestCase();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.scenario = object.scenario ?? "";
    message.variantId = object.variantId ?? undefined;
    message.language = object.language ?? "";
    message.simulatedAt = object.simulatedAt ?? undefined;
    message.expectedOutcome = object.expectedOutcome ?? "";
    return message;
  },
};

function createBaseUpdateTestCase(): UpdateTestCase {
  return {
    id: "",
    name: undefined,
    scenario: undefined,
    variantId: undefined,
    language: undefined,
    simulatedAt: undefined,
    expectedOutcome: undefined,
  };
}

export const UpdateTestCase: MessageFns<UpdateTestCase> = {
  encode(message: UpdateTestCase, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== undefined) {
      writer.uint32(18).string(message.name);
    }
    if (message.scenario !== undefined) {
      writer.uint32(26).string(message.scenario);
    }
    if (message.variantId !== undefined) {
      writer.uint32(34).string(message.variantId);
    }
    if (message.language !== undefined) {
      writer.uint32(42).string(message.language);
    }
    if (message.simulatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.simulatedAt), writer.uint32(58).fork()).join();
    }
    if (message.expectedOutcome !== undefined) {
      writer.uint32(66).string(message.expectedOutcome);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateTestCase {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateTestCase();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.scenario = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.variantId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.language = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.simulatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.expectedOutcome = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateTestCase {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      scenario: isSet(object.scenario) ? globalThis.String(object.scenario) : undefined,
      variantId: isSet(object.variantId)
        ? globalThis.String(object.variantId)
        : isSet(object.variant_id)
        ? globalThis.String(object.variant_id)
        : undefined,
      language: isSet(object.language) ? globalThis.String(object.language) : undefined,
      simulatedAt: isSet(object.simulatedAt)
        ? fromJsonTimestamp(object.simulatedAt)
        : isSet(object.simulated_at)
        ? fromJsonTimestamp(object.simulated_at)
        : undefined,
      expectedOutcome: isSet(object.expectedOutcome)
        ? globalThis.String(object.expectedOutcome)
        : isSet(object.expected_outcome)
        ? globalThis.String(object.expected_outcome)
        : undefined,
    };
  },

  toJSON(message: UpdateTestCase): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.scenario !== undefined) {
      obj.scenario = message.scenario;
    }
    if (message.variantId !== undefined) {
      obj.variantId = message.variantId;
    }
    if (message.language !== undefined) {
      obj.language = message.language;
    }
    if (message.simulatedAt !== undefined) {
      obj.simulatedAt = message.simulatedAt.toISOString();
    }
    if (message.expectedOutcome !== undefined) {
      obj.expectedOutcome = message.expectedOutcome;
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateTestCase>): UpdateTestCase {
    return UpdateTestCase.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateTestCase>): UpdateTestCase {
    const message = createBaseUpdateTestCase();
    message.id = object.id ?? "";
    message.name = object.name ?? undefined;
    message.scenario = object.scenario ?? undefined;
    message.variantId = object.variantId ?? undefined;
    message.language = object.language ?? undefined;
    message.simulatedAt = object.simulatedAt ?? undefined;
    message.expectedOutcome = object.expectedOutcome ?? undefined;
    return message;
  },
};

function createBaseDeleteTestCase(): DeleteTestCase {
  return { id: "" };
}

export const DeleteTestCase: MessageFns<DeleteTestCase> = {
  encode(message: DeleteTestCase, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteTestCase {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteTestCase();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteTestCase {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: DeleteTestCase): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<DeleteTestCase>): DeleteTestCase {
    return DeleteTestCase.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DeleteTestCase>): DeleteTestCase {
    const message = createBaseDeleteTestCase();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseSetTestCaseAssertions(): SetTestCaseAssertions {
  return { id: "", assertions: [] };
}

export const SetTestCaseAssertions: MessageFns<SetTestCaseAssertions> = {
  encode(message: SetTestCaseAssertions, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    for (const v of message.assertions) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetTestCaseAssertions {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetTestCaseAssertions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.assertions.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetTestCaseAssertions {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      assertions: globalThis.Array.isArray(object?.assertions)
        ? object.assertions.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: SetTestCaseAssertions): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.assertions?.length) {
      obj.assertions = message.assertions;
    }
    return obj;
  },

  create(base?: DeepPartial<SetTestCaseAssertions>): SetTestCaseAssertions {
    return SetTestCaseAssertions.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SetTestCaseAssertions>): SetTestCaseAssertions {
    const message = createBaseSetTestCaseAssertions();
    message.id = object.id ?? "";
    message.assertions = object.assertions?.map((e) => e) || [];
    return message;
  },
};

function createBaseSetTestCaseFunctionCalls(): SetTestCaseFunctionCalls {
  return { id: "", functionCalls: [] };
}

export const SetTestCaseFunctionCalls: MessageFns<SetTestCaseFunctionCalls> = {
  encode(message: SetTestCaseFunctionCalls, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    for (const v of message.functionCalls) {
      FunctionCallAssertion.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetTestCaseFunctionCalls {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetTestCaseFunctionCalls();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.functionCalls.push(FunctionCallAssertion.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetTestCaseFunctionCalls {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      functionCalls: globalThis.Array.isArray(object?.functionCalls)
        ? object.functionCalls.map((e: any) => FunctionCallAssertion.fromJSON(e))
        : globalThis.Array.isArray(object?.function_calls)
        ? object.function_calls.map((e: any) => FunctionCallAssertion.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SetTestCaseFunctionCalls): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.functionCalls?.length) {
      obj.functionCalls = message.functionCalls.map((e) => FunctionCallAssertion.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<SetTestCaseFunctionCalls>): SetTestCaseFunctionCalls {
    return SetTestCaseFunctionCalls.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SetTestCaseFunctionCalls>): SetTestCaseFunctionCalls {
    const message = createBaseSetTestCaseFunctionCalls();
    message.id = object.id ?? "";
    message.functionCalls = object.functionCalls?.map((e) => FunctionCallAssertion.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSetTestCaseTags(): SetTestCaseTags {
  return { id: "", tags: [] };
}

export const SetTestCaseTags: MessageFns<SetTestCaseTags> = {
  encode(message: SetTestCaseTags, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    for (const v of message.tags) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetTestCaseTags {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetTestCaseTags();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tags.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetTestCaseTags {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      tags: globalThis.Array.isArray(object?.tags) ? object.tags.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: SetTestCaseTags): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.tags?.length) {
      obj.tags = message.tags;
    }
    return obj;
  },

  create(base?: DeepPartial<SetTestCaseTags>): SetTestCaseTags {
    return SetTestCaseTags.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SetTestCaseTags>): SetTestCaseTags {
    const message = createBaseSetTestCaseTags();
    message.id = object.id ?? "";
    message.tags = object.tags?.map((e) => e) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
